/*

Pixel Field Editor - developed by Satori, s.r.o. (c) 2014-2016 - zden@satori.sk
---------------------------------
Legal notice: Source code is for internal purposes only of developing
and integrating Pixel Field Editor to the larger asset of Forms+Surfaces
online services. Any modifications must be discussed with Satori, s.r.o. and no derivates to other projects are allowed without prior written permission from Satori, s.r.o.
---------------------------------
Satori, s.r.o. | Jegeho 21 | 821 08 Bratislava | +421-903-258-862 | www.satori.sk

*/

// - - - - - - - - - - - - -
var dim_wid = 60;
var dim_hei = 60;
var dim_proj = 60;
var dim_new = 0;
var dim_bmp = 1024;
var shape_def = new Array(6);
var shape_def_size = 0;
var glass_type = 0;
var api_dim_callback = null;
var api_donefx_callback = null;
var api_setfx_callback_data = null;
var api_bitmap_callback = null;
var dim_api_wid = 0, dim_api_hei = 0;
var api_detail_data = { pos:[ 24, 24 ], dim:[ 12, 12 ], bleed:0 };
var api_detail_request = 0;
var api_detail_callback = null;
var api_layers = 2;
var api_fill_alpha = 1;
var api_slice = 0;

var image;
var img_scale = 0;
var image_ready = 0;
var image_drop = 0;
var image_data;
var grab_image_req = 0;
var x_res, y_res;
var img_x_res, img_y_res;

var val_change;

var time_start = -1;
var time;

var ComponentExportMode = {	AllLayers: 0, TopLayer: 1, BottomLayer: 2, TopWhiteLayer: 3, BottomWhiteLayer: 4 }; Object.freeze(ComponentExportMode);
var BinGroupNote = { None: 0, DigitalWhiteTop: 1, DigitalWhiteBottom: 2 };

function new_val()
{
	val_change = 1;
	//val_change_time = time;
}